import React from "react";
import { Alert } from "antd";

export default ({message, type}) => {
  return <Alert message={message} type={type} />;
};
